import { onScreenInSharedView, type RespondentQuestionContent } from "@digital-twins/shared-types";

function recordOf(value: unknown): Record<string, any> {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, any>)
    : {};
}

/** Every asset the compile gives twins, by id (`_canonicalConfig.assetContext.items`). */
export function compiledAssetIds(surveyJson: Record<string, unknown>): Array<string> {
  const items = recordOf(recordOf(surveyJson._canonicalConfig).assetContext).items;
  return Array.isArray(items) ? items.map((item) => String(recordOf(item).assetId)) : [];
}

/**
 * The assets a Quick Study question puts on screen in the shared view: all of
 * the compiled assets when the question is on screen there
 * (`onScreenInSharedView`), none otherwise. The one rule the full-size Preview
 * path (`previewSharedInstrumentDefinition`) and the question review
 * thumbnails both read.
 */
export function assetIdsShownInSharedView(
  surveyJson: Record<string, unknown>,
  question: RespondentQuestionContent,
): Array<string> {
  return onScreenInSharedView(question, surveyJson.testedAssets) ? compiledAssetIds(surveyJson) : [];
}
